import {SelectInput, ReferenceInput, TextInput} from 'react-admin';
import React from "react";

const ComboArea = (props) => {
    const isReadonly = props.readOnly;
    const isvariant = props.variant;
    return (
        <ReferenceInput label="Area" source="id_unidad_area" reference="UnidadArea"
                        // variant="outlined"
                        variant={isvariant===undefined || isvariant===null ? 'outlined' : isvariant.trim()}
        >
            <SelectInput optionText="area_d" InputLabelProps={{shrink: true}}
                         inputProps={{readOnly: isReadonly}}  />
        </ReferenceInput>
    )
};

export default ComboArea;
